/*
 * @Author: wp
 * @Date: 2023-01-11 18:34:36
 * @Descripttion:
 */
import getPageTitle from '~/utils/get-page-title'
import defaultSettings from '~/settings'

export default ({ app, store, $cookies }, inject) => {
	// 
	// return;
	const needLogin = defaultSettings.needLogin // no redirect whitelist

	app.router.beforeEach(async (to, from, next) => {
		if (to.name === 'servicesList' && to.params.buyType) {
			if (process.client) {
				document.title = to.params.buyType === 'RECOVERY' ? '号商' : '客服' + '列表'
			}
		}
		if (to.path !== '/goodsDetails' || to.path !== '/goodsList') {
			if (process.client) {
				// document.title = getPageTitle(to.meta.title);
			}
		}
		// const hasToken = getToken();
		const userToken = store.state.user.token
		if (userToken) {
			if (to.path === '/login') {
				next()
				let timeOut = setTimeout(() => {
					next('/')
					clearTimeout(timeOut)
				}, 100)
			} else {
				const hasGetUserInfo = store.state.user.userinfo
				if (hasGetUserInfo && hasGetUserInfo.id) {
					next()
				} else {
					// 登录后进来了这里
					try {
						// 获得用户信息
						await store.dispatch('user/UserGetInfo')
						next()
					} catch (error) {
						// 删除token，进入首页
						await store.dispatch('user/UserResetToken')
						next(`/login?redirect=${to.path}`)
					}
				}
			}
		} else {
			// await store.dispatch('user/UserResetToken')
			// 获得用户信息
			let pzdsCookie = $cookies.get('pzdsCookie') || ''
			if (pzdsCookie) {
				await store.dispatch('user/UserGetInfo')
				await store.commit('user/SET_TOKEN', pzdsCookie)
			}
			if (needLogin.indexOf(to.path) !== -1) {
				// 如果在需要登录的路由里面就跳到登录页面
				next(`/login?redirect=${to.path}`)
			} else {
				next()
			}
		}
	})

	//处理底部和顶部的隐藏
	// const path = ["/login", "/download", "/registered"]; //隐藏头部和底部的路由地址
	// app.router.afterEach(async (to, from, next) => {
	//   if (path.includes(to.path)) {
	//     await store.dispatch("AppPublicHidePage", false);
	//   } else {
	//     await store.dispatch("AppPublicHidePage", true);
	//   }
	// });
}
